import {
    AbstractControl,
    ValidationErrors,
} from '@angular/forms';

import { IValidatorOptions } from './validator.options';

export function required(options: IValidatorOptions = {}) {
    return (c: AbstractControl) => {
        const value = !!options.property ? c.value[options.property] : c.value;
        const isUndefined = value == null;
        const isString = typeof value === 'string';
        const isWhiteSpace = isString &&
            (
                !value ||
                !value.trim()
            );
        const isEmptyArray = value instanceof Array &&
            (
                value.length === 0 ||
                value.filter(v => v != null).length === 0
            );
        if (
            isUndefined ||
            isWhiteSpace && !options.allowWhitespace ||
            isEmptyArray
        ) {
            return {
                required: {
                    valid: false,
                },
            } as ValidationErrors;
        }
        return null;
    };
}
